module.exports = __webpack_public_path__ + "static/GrayGminaStezyca-2911facea47cdd7db23a5e375c18db18.svg";